<template>
<router-link to="/extension/wxMiniProgram" class="minapp-banner-advert" v-if="visible || showClose ===false">
  <div class="banner" />
  <div class="img-box center">
    <img class="banner-img" src="@/images/banner_1.png" />
    <img class="banner-img" src="@/images/banner_2.png" />
    <img class="banner-img" src="@/images/banner_3.png" />
    <img class="banner-img" src="@/images/banner_4.png" />
  </div>
  <svg-icon class="close-btn" icon="close" @click.prevent.stop="handeClose" size="24" v-if="showClose" />
</router-link>
</template>

<script>
import Cookies from 'js-cookie'
const COOKIE_KEY = 'minapp_banner_ad_hidden'
export default {
  name: 'MinappBannerAdvert',
  props: {
    showClose: Boolean,
  },
  data: () => ({
    visible: (Cookies.get(COOKIE_KEY) - 0) !== 1,
  }),
  methods: {
    handeClose() {
      Cookies.set(COOKIE_KEY, 1, { expires: 1 })
      this.visible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.minapp-banner-advert {
  display: block;
  cursor: pointer;
  height: 145px;
  position: relative;
  overflow: hidden;

  .banner {
    position: absolute;
    bottom: 0;
    left: 0;
    display: inline-block;
    vertical-align: bottom;
    width: 100%;
    height: 120px;
    border-radius: 4px;
    background: linear-gradient(135deg,
        rgba(85, 207, 255, 1) 0%,
        rgba(255, 255, 255, 1) 67%,
        rgba(255, 255, 255, 1) 100%);
  }

  .img-box {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: -2px;
    font-size: 0;
    white-space: nowrap;
  }

  .banner-img {
    margin-right: 60px;

    &:last-child {
      margin-right: 0;
    }
  }

  .center {
    text-align: center;
  }

  .close-btn {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    color: #A7A7A8;
  }
}

@media screen and (max-width: 1200px) {
  .ad {
    .banner-img {
      margin-right: 0px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
